import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { LoaderComponent } from './loader/loader.component';
import { SaverDeliveryMethodInfoComponent } from './bottom-sheets/saver-delivery-method-info/saver-delivery-method-info.component';
import { OrderLiveStatusComponent } from './order-live-status/order-live-status.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PendingFeedbackComponent } from './bottom-sheets/pending-feedback/pending-feedback.component';
import { MatMenuModule } from '@angular/material/menu';
import { DeliveryWindowComponent } from './bottom-sheets/delivery-window/delivery-window.component';

@NgModule({
  declarations: [
    HeaderComponent,
    LoaderComponent,
    SaverDeliveryMethodInfoComponent,
    OrderLiveStatusComponent,
    PendingFeedbackComponent,
    DeliveryWindowComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatProgressBarModule,
    MatRippleModule,
    MatMenuModule,
    RouterModule,
    MatIconModule
  ],
  exports: [HeaderComponent, LoaderComponent, OrderLiveStatusComponent]
})
export class CommonComponentsModule { }
